<template>
  <div id="renta-pagos">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget
            :title="'PAGOS RECIBIDOS DE LA RENTA ' + renta.folioRenta"
            color="primary darken-4"
            dark
          >
            <div slot="widget-content">
              <div>
                <v-layout row wrap>
                  <v-flex lg6>
                    <v-btn
                      color="success"
                      dark
                      fab
                      small
                      slot="activator"
                      @click="abrirDialogNuevoPago"
                    >
                      <v-icon dark>add</v-icon>
                    </v-btn>

                    <form-pago-renta
                      :renta="renta"
                      :rentaPago="rentaPago"
                      :nuevoPago="nuevoPago"
                      ref="dialogPagoRenta"
                      @onPagoAdded="onPagoAdded"
                      @onPagoUpdated="onPagoUpdated"
                    ></form-pago-renta>
                  </v-flex>
                  <v-flex lg6 class="text-xs-right">
                    <h4>
                      <span class="green--text"
                        >$ {{ formatMoney(renta.pagado) }}</span
                      >
                      / $ {{ formatMoney(renta.totalFinal) }}
                    </h4>
                  </v-flex>
                </v-layout>
              </div>

              <v-layout row wrap>
                <v-flex lg12>
                  <v-card>
                    <v-card-text class="pa-0">
                      <v-data-table
                        :headers="pagosRenta.headers"
                        :items="pagosRenta.data"
                        v-bind:pagination.sync="pagosRenta.pagination"
                        class="elevation-1"
                        item-key="numPago"
                      >
                        <template slot="items" slot-scope="props">
                          <td>{{ zeroFill(props.item.numPago, 3) }}</td>
                          <td>{{ props.item.fechaPago.substring(0, 10) }}</td>
                          <td>$ {{ formatMoney(props.item.montoPago) }}</td>
                          <td>{{ props.item.descripcionConceptoPago }}</td>
                          <td>{{ props.item.descripcionFormaPago }}</td>
                          <td>{{ props.item.referenciasPago }}</td>
                          <td>{{ props.item.observaciones }}</td>
                          <td>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="primary"
                              small
                              @click="editPago(props.item.numPago)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="pink"
                              small
                              @click="deletePago(props.item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import formPagoRenta from "./FormPagoRenta";

import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

import moment from "moment";

//Services
import rentaPagoService from "@/services/rentaPagoService";

export default {
  components: {
    VWidget,
    formPagoRenta,
    confirm,
    loadingAlert,
    snackBar,
  },
  props: {
    renta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pagosRenta: {
        headers: [
          { text: "#", align: "center", value: "numPago" },
          { text: "FECHA Y HORA", align: "center", value: "fechaPago" },
          { text: "MONTO", align: "center", value: "montoPago" },
          { text: "CONCEPTO", align: "center", value: "conceptoPago" },
          { text: "FORMA PAGO", align: "center", value: "formaPago" },
          { text: "REFERENCIA", align: "center", value: "referenciaPago" },
          { text: "OBSERVACIÓN", align: "center", value: "observacionPago" },
          { text: "ACCIONES", value: "acciones", align: "right" },
        ],
        data: [],
        pagination: { sortBy: "numPago", descending: true, rowsPerPage: -1 },
      },
      rentaPago: {
        rentaId: this.renta.rentaId,
        numPago: 0,
        fechaPago: moment(new Date()).format("YYYY-MM-DD"),
        horaPago: moment(new Date()).format("H:mm"),
        montoPago: 0.0,
        conceptoPagoId: null,
        formaPagoId: null,
        referenciasPago: "",
        observaciones: "",
        cambioDevuelto: 0,
      },
      nuevoPago: true,
    };
  },
  watch: {
    renta: function (renta) {
      this.getPagos();
    },
  },
  methods: {
    abrirDialogNuevoPago() {
      this.$store.state.tituloForm = "AGREGAR PAGO";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogPagoRenta.resetForm();
      this.rentaPago.numPago = this.pagosRenta.data.length + 1;
      this.rentaPago.horaPago = moment(new Date()).format("H:mm");
      this.$refs.dialogPagoRenta.openDialog();
      this.nuevoPago = true;
    },
    getPagos() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      rentaPagoService
        .getPagos(self.renta.rentaId)
        .then((result) => {
          self.pagosRenta.data = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    editPago(numPago) {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      rentaPagoService
        .getPago(self.renta.rentaId, numPago)
        .then((result) => {
          self.rentaPago = result;
          self.rentaPago.fechaPago = moment(result.fechaPago).format(
            "YYYY-MM-DD"
          );
          self.$store.state.tituloForm = "EDITAR PAGO";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";
          self.nuevoPago = false;
          self.$refs.dialogPagoRenta.resetForm();
          self.$refs.dialogPagoRenta.openDialog();
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    deletePago(rentaPago) {
      let self = this;

      this.$refs.confirm
        .open(
          "ELIMINAR PAGO",
          "¿Estás seguro de eliminar  el pago seleccionado?",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            rentaPagoService
              .delete(self.renta.rentaId, rentaPago.numPago)
              .then((result) => {
                var i = self.pagosRenta.data.findIndex(
                  (obj) => obj.numPago == rentaPago.numPago
                );
                self.pagosRenta.data.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text = "Pago eliminado con éxito";
                self.$store.state.snackbar.visible = true;

                this.recalcularTotalPagado();

                this.$emit("onPagoDeleted", rentaPago);
              })
              .catch((e) => {
                console.log(e);
                self.operationFailed(e);
              })
              .finally(() => {
                self.$store.state.loadingInfo.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    onPagoAdded(rentaPago) {
      this.pagosRenta.data.push(rentaPago);
      this.renta.pagado += rentaPago.montoPago;
      this.verificarCorteCaja()
      this.$emit("onPagoAdded", rentaPago);
    },
    onPagoUpdated(rentaPago) {
      var i = this.pagosRenta.data.findIndex(
        (obj) => obj.numPago == rentaPago.numPago
      );
      this.pagosRenta.data.splice(i, 1, rentaPago);

      this.recalcularTotalPagado();
      this.verificarCorteCaja()
      this.$emit("onPagoUpdated", rentaPago);
    },
    recalcularTotalPagado() {
      //Recalcular monto pagado
      this.renta.pagado = 0;
      this.pagosRenta.data.forEach((pagoRenta) => {
        this.renta.pagado += pagoRenta.montoPago;
      });
    },
  },
};
</script>
